import React from 'react';
import './Education.css';

const Education = () => {
  return (
    <div className='container'>
      <main className="row">
        {/* Education Section */}
        <section className="col">

          <header className="title">
            <h2>Education</h2>
          </header>

          <div className="contents"> {/* Fix: Use 'div' instead of 'class' */}
            <div className="box">
              <h4>2015-2017</h4>
              <h3>High School</h3>
              <p>I completed my High School diploma from ST Francis School. During this Time I engaged in courses like Java, Science and Maths. </p>
            </div>

            <div className="box">
              <h4>2017-2019</h4>
              <h3>Pre Degree</h3>
              <p>I Completed My Predegree in Science From kadachira HSS in kerala,India. I Have done the course in Science,Maths and Literature.</p>
            </div>

            <div className="box">
              <h4>2019-2022</h4>
              <h3>Bachelor's Degree</h3>
              <p>I have completed My Bachelor's in Computer Application from Alva's college In karnataka, india. At this time, i engaged in courses like Web Development, Relational Database, Python and Data Structures & Algorthims.</p>
            </div>
          </div>
        </section>

        {/* Experience Section */}
        <section className="col">
          <header className="title">
            <h2>Experience</h2>
          </header>

          <div className="contents"> {/* Fix: Use 'div' instead of 'class' */}
            <div className="box">
              <h4>2023-Present</h4>
              <h3>Front End Developer Intern</h3>
              <p>As a Front End Developer at radicalX. I collaborated with development team to create visually appealing user interfaces in React, HTML and CSS.</p>
            </div>

            <div className="box">
              <h4>2022-present</h4>
              <h3>React Developer in BlueLearn</h3>
              <p>BlueLearn is a Student Community That provide platform for Student to grow and learn new skills while doing projects. I have created React Projects in BlueLearn.</p>
            </div>

            <div className="box">
              <h4>2019</h4>
              <h3>IOT Intern</h3>
              <p>Hands-on experience working with IoT technology and devices, such as sensors and microcontrollers. Exposure to different IoT platforms and tools, such as arduino, Firebase etc.</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Education;
